import React from "react";
import { Container, Button } from "react-bootstrap";
import { useNavigate } from "react-router";
import SEOHelmet from "./components/SEOHelmet";

import "../styles/Error404.scss";

function Error404() {
  const navigate = useNavigate();

  return (
    <div className={"pt-5"}>
      <SEOHelmet
        title="Seite nicht gefunden - Computer Center Lorentschitsch"
        description="Die angeforderte Seite konnte nicht gefunden werden. Kehren Sie zur Startseite von Computer Center Lorentschitsch zurück."
        keywords="404, Seite nicht gefunden, Computer Center Lorentschitsch"
        canonical="https://lorentschitsch.at/404"
      />

      <div className="error404">
      </div>
    </div>
  );
}

export default Error404;